/**
 * What the Custom Difficulty panel accepts (the desktop editor's F11 panel, `Track.cs` `DoCustomDiffEdit`
 * and its `CustomDifficultyEdit` save; the field limits are on its two InputFields in Editor.unity):
 *   - the name is Alphanumeric (ASCII letters and digits only) and at most 8 characters;
 *   - the speed is clamped to 1 to 3 (the desktop types a decimal; the web panel steps whole numbers);
 *   - a name left empty leaves it as it was.
 * Pure functions, so the panel and the tests ask the same question.
 */

export const CUSTOM_NAME_MAX = 8;
export const CUSTOM_SPEED_MIN = 1;
export const CUSTOM_SPEED_MAX = 3;

/** The name field's text after typing or pasting `raw`: letters and digits only, 8 at most. */
export function sanitizeCustomName(raw: string): string {
  return raw.replace(/[^A-Za-z0-9]/g, '').slice(0, CUSTOM_NAME_MAX);
}
